export const roadB2 = [
    {
        id: 0,
        thumbnail:"https://i.ibb.co/pBgwzxqm/B2-FIRST-24-removebg-preview.png",
        title: "English Verb Patterns",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "📒[slides] Transitive and Intransitive Verbs",url: "https://drive.google.com/file/d/1q9Ay8KRUU9tSwuHEvjIM8bKZ3PWCyjkZ/view?usp=sharing", },
            { titulo: "📒[slides] Gerunds and Infinitives Explanation",url: "https://drive.google.com/file/d/1rE08bQrEyF0TVO7FTYWGtLaiOGKuLjRO/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 1",url: "https://drive.google.com/file/d/1KJKLqjSwQeILyViRun9ADqge1ikKPmSD/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 2",url: "https://drive.google.com/file/d/19WY1c2LJZrAjj84niwx-u5dgh-dafQb6/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 3",url: "https://drive.google.com/file/d/1xURjjQPkur3dYBtFRuZTmbnqlC-ZCb2b/view?usp=sharing", },
            { titulo: "💡  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1H6BxX1OPZ-5fU7peCACnw6vRV5-lnUPW/view?usp=sharing", },
            { titulo: "🔑  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1OYpGW81Wt7dvLTsTa7zddJRJIKKo7Mpn/view?usp=sharing", },
            { titulo: "💡  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1GOe8JtMyfLpayGkIgkUn1IkGRblKsoGf/view?usp=sharing", },
            { titulo: "🔑  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1iAOBovzOkjJH9Z9rToPCj8losTuXz9ov/view?usp=sharing", },
            { titulo: "🧩  Desafio gerund vs infinitive",url: "https://wordwall.net/play/7240/772/7948", },
            { titulo: "🧩  Desafio gerund vs infinitive II",url: "https://wordwall.net/play/22920/270/462", },
            { titulo: "🧩  Desafio gerund vs infinitive III",url: "https://wordwall.net/play/76232/915/656", },
            { titulo: "🧩  Desafio gerund vs infinitive IV",url: "https://wordwall.net/play/71477/712/378", },
            { titulo: "🧩  Desafio gerund vs infinitive V",url: "https://wordwall.net/play/75464/667/869", },
            { titulo: "🧩  Desafio gerund vs infinitive VI ",url: "https://wordwall.net/play/59257/372/969", },
            { titulo: "🧩  Desafio gerund vs infinitive VII ",url: "https://wordwall.net/play/4838/285/4447", },

           
           



          
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },

            
        ],
    },

    {
        id: 1,
        thumbnail:"https://i.ibb.co/pBgwzxqm/B2-FIRST-24-removebg-preview.png",

        title: "Grammar Showdown",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"Welcome",descripcion:"Las diferencias en Inglés ",url: "https://drive.google.com/file/d/1xTKk8uS9tVBQ4rk-X4-VEBA3ZUAwCIW8/view?usp=sharing"},

            { titulo:"Leave vs Forget",descripcion:"Diferencias en uso ",url: "https://drive.google.com/file/d/1y_j2Do4YAErfoQdNLDu5yXaxjgW0FH8O/view?usp=sharing" ,url2: "https://youtu.be/ZuTu0cKrgA4?si=SwLXrU0zQTyxjNDz",url3: "https://drive.google.com/file/d/16EXaLrUSI1-6HPIwplL6mLjakFsnLRfu/view?usp=sharing"},
            { titulo:"Continuamente ",descripcion:"Diferencias en uso",url: "https://drive.google.com/file/d/1kENm-lqtM22jiVAej6_Io_IoYFeRDprC/view?usp=sharing",url2: "https://youtu.be/DXCOSUsATsE?si=KXNzdx8qbzOeCMkz",url3: "https://drive.google.com/file/d/17UWJLib-ZYETsEc-rF0p3byGvy24R_kY/view?usp=sharing"},
            { titulo:"Shout at vs Shout to",descripcion:"Diferencias en uso",url:"https://drive.google.com/file/d/1iisgsGHkBpj0nyGTvwxCiI8_aG3ukcsi/view?usp=sharing" ,url2: "https://youtu.be/QAJVD14o2a8"},
            { titulo:"Afraid ",descripcion:"Como usarlo",url: "https://drive.google.com/file/d/1X_G4Rvia8Lpu4C5MHXcLx7dXtUnfFsZb/view?usp=sharing"},
            { titulo:"Afraid to do vs Afraid of doing ",descripcion:"Diferencias claves",url:"https://drive.google.com/file/d/19XX67MnZ-Mf-rmq9pPlYm9GMogYOHQa_/view?usp=sharing",url2: "https://youtu.be/pYaZjZIQBdM",url3: "https://drive.google.com/file/d/1cCllRuslCkOJyqtgAhukNp_eGwN94zre/view?usp=sharing"},
            { titulo:" Encrucijada de Opciones ",descripcion:"Rather than, Instead of, As opposed to",url: "https://drive.google.com/file/d/13ZK9zCLBTKe73OQNaqvXjK-38ZvaJ8VT/view?usp=sharing",url3: "https://drive.google.com/file/d/1iqoLUXkRQqElYsf7faswD-xSfsSSuR9X/view?usp=sharing"},
            { titulo:" El Laberinto de la Prevención",descripcion:"Prevent, Stop, Avoid",url: "https://drive.google.com/file/d/1FoSc6244qwfBpG9EDxzX7YkHZTuk6EN8/view?usp=sharing"},
            { titulo:" El Reto de la Precisión",descripcion:"Differentiate, Distinguish, Discriminate",url: "https://drive.google.com/file/d/1v-uIHL_GseKjuslDEgVGhiTajGCL9CQs/view?usp=sharing"},
            { titulo:" Profecías del Futuro Cercano ",descripcion:"Immediate Future Expressions",url: "https://drive.google.com/file/d/1mOBysPhkjDIvx1ePzrM-LMnlrsGZuOzb/view?usp=sharing"},
            { titulo:"Rather than , Instead of . As opposed to",descripcion:"Continually, Continuously, Constantly",url: "https://drive.google.com/file/d/13ZK9zCLBTKe73OQNaqvXjK-38ZvaJ8VT/view?usp=sharing"},
            { titulo:" Los Límites del Territorio ",descripcion:"As far as, Until, Up to",url: "https://drive.google.com/file/d/16CJjTB0ZPDvQuzpOLMR22R0jK7QCe-c3/view?usp=sharing"},
            { titulo:" El Secreto del Buen Trabajo ",descripcion:"It's a good job /a good thing/just as well  that",url: "https://drive.google.com/file/d/1vHHH_2VXuIdDf_NSp6Ie9FgvHFB94G92/view?usp=sharing"},
            { titulo:"Chance of-Chance to... ",url: "https://drive.google.com/file/d/18otkt_PTLMwlZGqs4rBnXRMdhz48xUaS/view?usp=sharing"},
            { titulo:"feel like (doing) sth vs feel up to (doing) sth",url: "https://drive.google.com/file/d/1yVw8CbCu3FMAUYVJyKj42IoujDRxF1Iv/view?usp=sharing"},
            { titulo:"Wait ,Await, Expect ",url: "https://drive.google.com/file/d/1C1llJJ8yFX0i5pxSnTMUWPIjmNvISnHB/view?usp=sharing"},
            { titulo:"Raise vs Rise..",url: "https://drive.google.com/file/d/1K57hHa19p8k36dka59AM7pyFERFxnap2/view?usp=sharing"},
            { titulo:"sidetrack - distract - put someone off",url: "https://drive.google.com/file/d/1uXbNu9yt24xuTIVk0u60JO0lxdxT9Wt8/view?usp=sharing"},
            { titulo:"sign vs signal",url: "https://drive.google.com/file/d/1HhFh07shRGd8N9LoKQtuSj21YBq2TCMV/view?usp=sharing"},
            { titulo:"in the suburbs vs on the outskirts",url: "https://drive.google.com/file/d/1JMop9SCD1WVrMeQiXTFRD0IcsBqD-vjn/view?usp=sharing"},
            { titulo:"Notice - realize - be aware",url: "https://drive.google.com/file/d/1ZUCrPpie-3e4GKFt5xuyqDXvdF4EwQ1P/view?usp=sharing"},
            { titulo:"TIME vs MOMENT",url: "https://drive.google.com/file/d/1DLFl-bn78Abyr-UQYLh9LN2J45t9UO8Q/view?usp=sharing"},
            { titulo:"Trust ,Distrust ,Entrust ",url: "https://drive.google.com/file/d/1gC2SLjM0tML-TVWLjl6a4V6wHYYkokbp/view?usp=sharing"},
            { titulo:"📚In the (short/medium /long) term / in the (short/long)run ",url: "https://drive.google.com/file/d/1OLnc9y-xWYZeoPXocHl4T0Hlow-W7-Jf/view?usp=sharing"},

        ],
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/vcMnX0n/B2-FIRST-17.png",
        title: "Recursos Descargables",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"📒 Study Guide",url: "https://drive.google.com/file/d/1pKc3ccQW3ToLCZo3Hpl-t7AztxsMokMD/view?usp=sharing",url2:"https://youtu.be/Ge1WzZFQm9w"},

            { titulo:"English - Listening and speaking  B2",url: "https://drive.google.com/file/d/1WWS3zyzQlu_5Zkv0y9HqRJMT9CeQnkpl/view?usp=sharing"},
            { titulo:"Cambridge B2 ",url: "https://drive.google.com/file/d/1CU9wjKF6k91uq1vgXAiSPx9LQmIP9Gos/view?usp=sharing"},
            { titulo:"B2/C1 Vocabulary",url: "https://drive.google.com/file/d/1v46CdxreA1fd9G6L9bzttZrP2zEu5zs7/view?usp=sharing"},
            
        ],
    },


    {
        id: 2,
        thumbnail:"https://i.ibb.co/GGxkRKV/Chat-GPT-Image-28-mar-2025-13-53-07.png",
        title: "Phrasal Quest",
        subtitle: "B2/C1",

        dateAdded: "Week 01 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"Welcome",descripcion:"Las diferencias en Inglés ",url: "https://drive.google.com/file/d/1VTKLgs-w-Bc-_TPtmNScaaQf0ATs8oCl/view?usp=sharing"},

            { titulo:" Be on about ",descripcion:"Todos los usos y diferencias",url: "https://drive.google.com/file/d/1i5m5Xo0rahB9re9xsLNJdclpA8FA03jy/view?usp=sharing",url3: "https://drive.google.com/file/d/1JDpCXxAU9ozjBMEA2ouhBQGAJgpliOOc/view?usp=sharing" },
            { titulo:"📚Watch out for - Look out for.pdf",url: "https://drive.google.com/file/d/1-E-NvIWN5EmPErBDwZSZmoAQZdgC4g4O/view?usp=sharing"},
            { titulo:"📚ASK FOR - ASK AFTER - ASK ABOUT",url: "https://drive.google.com/file/d/1gkbuIZJ6sRy1jro8NPpOZLKO4p7naizC/view?usp=sharing"},
            { titulo:"Work Out ",url: "https://drive.google.com/file/d/1h4pzMnsgFmBcpRj1QbPbBDjkJ0J9UYfE/view?usp=sharing",url3:"https://drive.google.com/file/d/14ovf4SmbRkZSWQVh-6Q9cOCousRjCrvZ/view?usp=sharing"},

            { titulo:"zero in on  ",descripcion:"Todos los usos y diferencias",url: "https://drive.google.com/file/d/18JztqKh0PP18_LPzUKZDJYnRQqip7x3a/view?usp=sharing",url3: "https://drive.google.com/file/d/19y7aXWFScceuArjQNuN7FjpaLPfALo3w/view?usp=sharing" },

            { titulo:"Shy Away From sth   ",descripcion:"Todos los usos y diferencias",url: "https://drive.google.com/file/d/1LKd3X2Qr8MJ-52QtwBi9f6NR-AWD9anl/view?usp=sharing",url3: "https://drive.google.com/file/d/188wbcEig0wGPF2gscPLlQhF_xayYwKHF/view?usp=sharing" },
        ],
    },
 
    {
        id: 3,
        thumbnail: "https://i.ibb.co/Jj8dwTCN/Chat-GPT-Image-28-mar-2025-10-34-49.png",

        title: "Real English Grammar",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"[📑 Tense Infographic ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing"},

            { titulo:"Saxon genitive",url: "https://drive.google.com/file/d/1vRBsRnPMX_9m_wNUkAvs2phvuR8DYHqD/view?usp=sharing",url3:"https://drive.google.com/file/d/18PItis9izfn8oMa-2V91VTX3SQq9W2Tq/view?usp=sharing"},
            { titulo:"Saxon vs Of",url: "https://drive.google.com/file/d/1LeR_MDZFr_BJhZ3fu16vg6eUuvUQri3o/view?usp=sharing"},
            { titulo:"📚That's why - that's because.pdf",url: "https://drive.google.com/file/d/1-VKBz1cVT8zW1yZFf1QYGry984MX7BML/view?usp=sharing"},

            { titulo:"Vocabulary 01",url: "https://drive.google.com/file/d/17OdvZytOobwQmpNyA5boo4a7SUfBnJtC/view?usp=sharing",url3:"https://drive.google.com/file/d/1mre82d_iD2qyoDP9IG6nmGGNooLOnlK5/view?usp=sharing"},
          
            { titulo:"Obtener Codigo",url: "https://drive.google.com/file/d/1elKV4DgU5egBqau8EzDvYkub2OCfiORs/view?usp=sharing"},


        ],
    },
    {
        id: 2,
        thumbnail:"https://i.ibb.co/b53R08DX/file-BEBHv-Yhkgbs-E4pxzmsb5-Sd.png",
        title: "Real Grammar in use 02",
        subtitle: "B2/C1",

        dateAdded: "Week 01 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"📑 Verbs 01",url: "https://drive.google.com/file/d/12Kh_QqxgHwz6dT7Vos8XAh-sZzYbc4hZ/view?usp=sharing"},
            { titulo:"📚no good vs not good.pdf",url: "https://drive.google.com/file/d/1-5MHEN322Xi2xUYpDWYU115P2NXYQzdr/view?usp=sharing"},
            { titulo:"📚[ppt] Used to/ be used to / get used to   ",url: "https://drive.google.com/file/d/1t9c1CP7VuTePAYy00qC3r85qRNoBM-7v/view?usp=sharing"},
            { titulo:"📚MADE (OF, OUT OF, UP OF, FROM, WITH).pdf ",url: "https://drive.google.com/file/d/1-Mw6MXOBx3V6D0WvlN1l3Hn6XGBTrolK/view?usp=sharing"},
            { titulo:"📚Make the most, Make the best, Get the better...pdf ",url: "https://drive.google.com/file/d/1pQvtcWZpqNw-8sWDfAST6b0DfqpubGz1/view?usp=sharing"},
            { titulo:"📚CERTAINTY and Possibility.pdf ",url: "https://drive.google.com/file/d/1mm_5Vu6RvtWArxSLoK5sXT3cR5XVzWWJ/view?usp=sharing"},
            { titulo:"📚MORE vs ELSE.pdf ",url: "https://drive.google.com/file/d/1vcmTTeSYW8DsLahQRM_WCGG-PYdeRmET/view?usp=sharing"},
            { titulo:"📚MOST OF ALL...pdf ",url: "https://drive.google.com/file/d/1q9UddjPgJnivJ3jw1O4YUeFZQB38brVl/view?usp=sharing"},
            { titulo:"📚Neither + singular or plural..pdf ",url: "https://drive.google.com/file/d/1-Q9yKb-unyv3FAKZLhiU5nVrjc0-yu3x/view?usp=sharing"},
            { titulo:"📚Not only... but also...(structure)",url: "https://drive.google.com/file/d/1oXgZlGy5JdqxtVyzTQ-hiAfeyWadDkpG/view?usp=sharing"},
            { titulo:"Despite & In spite of",url: "https://drive.google.com/file/d/1Mz8VnETibHBD0ID3hanTfrNS66xHU6_h/view?usp=sharing"},
            { titulo:"Hope ",url: "https://drive.google.com/file/d/1TcYDUgDV2y6dJcIJRToStpzojqNYu0iB/view?usp=sharing"},

        ],
    },
    {
        id: 19,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Prepositions",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"Colocation with On ",descripcion:"Aprenderemos las colocaciones mas frecuentes",url: "https://drive.google.com/file/d/1bUfF1EATw-gkYy4_D5mw9y_zAnpQebIy/view?usp=sharing",url2:"https://youtu.be/G0FOLPlRx7g"},
            {  titulo:"Preposition 01 ",descripcion:"Be go out of fashion/on the increase/on the news",url: "https://drive.google.com/file/d/11SMHLs54sJoIkQMaBcp_c4gN9q_rB-S8/view?usp=sharing",url2:"https://youtu.be/V0eF1Yx9OoU"},
            {  titulo:"Preposition 02 ",descripcion:"In brief/be under the impression/by mistake",url: "https://drive.google.com/file/d/1AVgvB-leSksusal7IRaT1qE08CPDXNi6/view?usp=sharing",url2:"https://youtu.be/nATMol35GwY?si=OWkCVt1OPt0mlQIw"},
            {  titulo:"Preposition 03 ",descripcion:"on-in time/ in honor of/under-over age",url: "https://drive.google.com/file/d/1w_Vnyj2nUHelXYMGrh_zzTlSu8P7fppy/view?usp=sharing",url2:"https://youtu.be/nATMol35GwY?si=OWkCVt1OPt0mlQIw"},

            {  titulo:"📝Prepositions 01 ",url: "https://drive.google.com/file/d/1ybpVAlxfM2Zvqe8xxBOPVCfFVCgk-W9U/view?usp=sharing"},
            {  titulo:"📝Prepositions 02 ",url: "https://drive.google.com/file/d/1PlFqX6zlyiNyjqOlaYQka6IeDomq0e0E/view?usp=sharing"},
            {  titulo:"📝Prepositions 03 ",url: "https://drive.google.com/file/d/1wDbMgx8z91WcmuY-6tF_aFLoRGhrXKd-/view?usp=sharing"},
            {  titulo:"📝Prepositions 04",url: "https://drive.google.com/file/d/1UHVi7z-9D8Es-kCBqmooDYLDlfB5vBct/view?usp=sharing"},
            {  titulo:"📝Prepositions 05 ",url: "https://drive.google.com/file/d/1ZqQgXsnezJZNDhCBA_3xO90IlsO3oN6o/view?usp=sharing"},
           
            { titulo:"📑Interested in vs Interested to.pdf ",url: "https://drive.google.com/file/d/1vbKk7R4t3Zq1Zsfkl-3F3DPyhU2NXzhe/view?usp=sharing"},
            { titulo:"📑Sorry to/about/for ",url: "https://drive.google.com/file/d/1BrzsIhSqoqY7IWbRVQtwsvWWzciozGzr/view?usp=sharing"},
            { titulo:"☠️ Exam Prepositions 01 ",url: "https://drive.google.com/file/d/1Nea8nudn5VaF3B7RodO-5nmZOYr0koq4/view?usp=sharing"},
            { titulo:"🔑 Exam Key Prepositions 01 ",url: "https://drive.google.com/file/d/1oTS5PeWp8RPWcBzx0pCypXuI1WmWnjlI/view?usp=sharing"},
            { titulo:"📚At, In, By ( the end)..",url: "https://drive.google.com/file/d/1agtpiCvGtERX_ee7wHpNaax0hU1OmXyp/view?usp=sharing"},
            { titulo:"📚count on - depend on - rely on",url: "https://drive.google.com/file/d/1DxZyMcb1NwXXbt_wIAbhPTiNFMuvAKG6/view?usp=sharing"},

            { titulo:"📚BY, IN, ON + ING",url: "https://drive.google.com/file/d/1VmZIuWIV0IXYDd1RGtIo7krxPcBPGLOF/view?usp=sharing"},
            { titulo:"📚for sale - on sale - in the sale",url: "https://drive.google.com/file/d/1X4c4ZKEORCzHHE1SC0RVPRuDwRdB-hwb/view?usp=sharing"},
            


        ],
    },
    {
        id: 25,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Word Formation (B2)",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ WF001 - Negative Forms ",url: "https://drive.google.com/file/d/1FoMiuTrYJHxJYyBsbBrqvs10Kb8cYf2T/view?usp=sharing", },    
            { titulo: "✍ WF002 - Prefixes and Negative Meanings ",url: "https://drive.google.com/file/d/1NI-L5UBxQ5gFeRac6oVhMXD_T-5YCjiv/view?usp=sharing", },    
            { titulo: "✍ WF003 - Crossword - Word Formation ",url: "https://drive.google.com/file/d/194QnF1Gc-wIRpiWAOtqWy-D8B78coaSL/view?usp=sharing", },    
            { titulo: "✍ WF004 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1j5T_mLOody8iDftkPJLcsPjNZ3pK9ot2/view?usp=sharing", },    
            { titulo: "✍ WF005 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1GAfwTA5CIrNcDW6hFA-Nbok78IlKdrh9/view?usp=sharing", },    
            { titulo: "✍ WF006 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1VsED-djskHE3PJwF2U8fXGPhENb07SxJ/view?usp=sharing", },    
            { titulo: "✍ WF007 - Word Formation Sentences ",url: "https://drive.google.com/file/d/11PrvYO0MoUzPqjgWwhPFARAdU9hOoKx8/view?usp=sharing", },    
            { titulo: "✍ WF008 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1susqk-7RPZOjTMidwHWzk2EDWCY_54CO/view?usp=sharing", },    
            { titulo: "✍ WF009 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1S9N--Mr5SS0nS7v3GLp4Xh2MKkhGh2d1/view?usp=sharing", },    
            { titulo: "✍ WF010 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1-W82gGyyTEkwiNn8_7n54jcS4vED76Fm/view?usp=sharing", },    

            { titulo: "✍ WF011 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1I4gNHDTaMU9lNwGsEv8Fyqct9NU2eXyR/view?usp=sharing", },    
            { titulo: "✍ WF012 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1aJM4ArL2IIOc48AM5tAhCUvf1MhWXfal/view?usp=sharing", },    
            { titulo: "✍ WF013 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1U0drN7vU3cQ67HifCfJcE0IpEt5jeUad/view?usp=sharing", },    
            { titulo: "✍ WF014 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1GpFgkjeAIjSzFftj3fLuo70W2K96CHEH/view?usp=sharing", },    
            { titulo: "✍ WF015 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1QampSegCjNaiMXPSvylWpawvPSwYoU6C/view?usp=sharing", },    
            { titulo: "✍ WF016 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1bfRaXcHxF_jtjmrdkIJYNi3-7kDRUAo6/view?usp=sharing", },    
            { titulo: "✍ WF017 - Word Formation Sentences ",url: "https://drive.google.com/file/d/18Omg11ZTsuP2_FAj1ygXHASgA70SVCq8/view?usp=sharing", },    
            { titulo: "✍ WF018 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1J2ZcjSpAXztp2Aw12RnYgh4w2FT0B3Xb/view?usp=sharing", },  
            
            
            { titulo: "✍ WF019 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/18krxCjRSmgc3wfWPtGK2qggwq0lUlfnW/view?usp=sharing", },    
            { titulo: "✍ WF020 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/18J49WKoMt8jXjiKAcxrFnaqTykF-0QHw/view?usp=sharing", },    
            { titulo: "✍ WF021 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/17L45VWvsHTY1ToaELcaEXaIpT8bgSKRB/view?usp=sharing", },    
            { titulo: "✍ WF022 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1pQvadnaDQBG7XFiBmcTBWcd63U9Ev5o0/view?usp=sharing", },    
            { titulo: "✍ WF023 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1C9hVqtk28R1nm-hx65SgSHl3_YDCZyVF/view?usp=sharing", },    
            { titulo: "✍ WF024 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1vLs14YohPvffTs6s3PuFznGWKsM0_1TV/view?usp=sharing", },    
            { titulo: "✍ WF025 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1w45SJf4eSJkURAPHI4Be2ygqhUfH8oGb/view?usp=sharing", },    
            { titulo: "✍ WF026 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1ut_DldDoGR9ZqmMBjztnq2V_jtvyc6xW/view?usp=sharing", },    

            
        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Connectives and Linking Phrases ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
            { titulo:"📚[pdf] Connectives and Linking Phrases 001 ",url: "https://drive.google.com/file/d/1E-4DPNChktOiBETwI-npC9fPdRGotUqQ/view?usp=sharing"},
            { titulo:"📚[pdf] Connectives and Linking Phrases  002 ",url: "https://drive.google.com/file/d/1n3fWZPpV_DY9QCpUyvRqwO1wTMYZ67jA/view?usp=sharing"},
            { titulo:"📚[pdf] Connectives and Linking Phrases  003 ",url: "https://drive.google.com/file/d/1sxWll8fBOnh8JxQSUEYSF6ez4xqLhe3F/view?usp=sharing"},
            { titulo:"📚[pdf] Connectives and Linking Phrases  004 ",url: "https://drive.google.com/file/d/1nREywm6HXbce0qeVlH_kkcTV-DIAEtJI/view?usp=sharing"},

          
        ],
    },
    
    
    {
        id: 0,
        thumbnail:"https://i.ibb.co/tphjRLC8/Chat-GPT-Image-27-mar-2025-10-15-21.png",
        title: "B2 Bootcamp ",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
           
                { "titulo": "B2 first Essential", "url": "https://www.youtube.com/watch?v=gGWtrDuoUi0" },
                { "titulo": " day 2", "url": "https://www.youtube.com/watch?si=MHjaEN7bzBy3ZOhc&v=9bB9PgyB_bg&feature=youtu.be" },
                { "titulo": " after", "url": "https://www.youtube.com/watch?v=5ilyP5xsyes&feature=youtu.be" },
                { "titulo": " day 3", "url": "https://www.youtube.com/watch?si=m4xdSF6v23GibP_H&v=CR6rnB5Yg0Y&feature=youtu.be" },
                { "titulo": " day 4", "url": "https://www.youtube.com/watch?si=tixxZisScjmyyLzI&v=eOtsLBuwvgw&feature=youtu.be" },
                { "titulo": "day 5", "url": "https://www.youtube.com/watch?si=dYFzG1VF98Tqkvyi&v=I5E5Q3yByPs&feature=youtu.be" },
                { "titulo": "  day 6", "url": "https://www.youtube.com/watch?si=-KYzJRc2XtTsfytL&v=OuqZlRsw7NE&feature=youtu.be" },
                { "titulo": " day 7", "url": "https://www.youtube.com/watch?v=4hyP05BgB9M&list=PLaYNhMsVRuHhY6xcwxg931ib5xCbw2zWC&index=8&ab_channel=MyEnglishBro" },
                { "titulo": " day 8", "url": "https://www.youtube.com/watch?v=XE7dOWDGpek&ab_channel=MyEnglishBro" },
                { "titulo": "day 9", "url": "https://www.youtube.com/watch?v=w2i-Q7YHpvc" },
                { "titulo": " day 10", "url": "https://youtu.be/1yYDsB_X9Ow" },
                { "titulo": " day 11", "url": "https://www.youtube.com/watch?v=G7noYDWA80I&ab_channel=MyEnglishBro" },
                { "titulo": " day 12", "url": "https://youtu.be/96wYFY3lUh4" },
                { "titulo": " day 13", "url": "https://www.youtube.com/watch?v=tVZPNUMq2d0&ab_channel=MyEnglishBro" },
                { "titulo": " day 14", "url": "https://www.youtube.com/watch?v=RAY0LxAjNOk&ab_channel=MyEnglishBro" },
                { "titulo": " day 15", "url": "https://www.youtube.com/watch?v=Czy1TEgGXu4&ab_channel=MyEnglishBro" },
                { "titulo": " day 16", "url": "https://www.youtube.com/watch?v=NZjOZDjhK3E" },
                { "titulo": "  day 17", "url": "https://www.youtube.com/watch?v=gpbEMX4KPk8" },
                { "titulo": "  day 18", "url": "https://www.youtube.com/watch?v=ez9eoYxzU-A&ab_channel=MyEnglishBro" },
                { "titulo": "  day 19", "url": "https://youtu.be/t1njSOFuS84" },
                { "titulo": "  day 20", "url": "https://youtu.be/oNkeUNBrjG0" },
                { "titulo": "  day 21", "url": "https://youtu.be/MdL2xj330bk" },
                { "titulo": " day 22", "url": "https://youtu.be/LYrMkpMS5RY" },
                { "titulo": "  day 23", "url": "https://youtu.be/iYdTP-7wvzc" },
                { "titulo": "  day 24", "url": "https://youtu.be/esjEITmf8Ug" },
                { "titulo": "  day 25", "url": "https://youtu.be/OxXnEdw-LdU" }
            ],
            
    },

    {
        id: 2,
        thumbnail:"https://i.ibb.co/Qvzg24T4/file-YU8-CLywp-Xm-Ewi69wvopi-We.png",


        title: "B2 First 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=R2TVluocgUg&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=kLjAWxOYZDI&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=_FJtW3NHYxQ&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=uSoQGya3n_Y&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=ccyWNJz7FS4&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=4&ab_channel=MyEnglishBro" },
                
            ],
            
    },
    {
        id: 3,
        thumbnail:"https://i.ibb.co/fdvHb0wg/file-Fg-Ck-CXPth2-Nv-VVv4mnbaiq.png",

        title: "IELTS Band 5",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=nIZcH0sQSf0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=1&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=C0RB86t1YIw&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=TV10GT7j_es&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=2ExYgxh9gjE&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=UEEEwLpO7z0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=4&ab_channel=MyEnglishBro" },
                
            ],
            
    },
    
   
   
    {
        id: 0,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Simple Arc",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
           
            { titulo:"Present Simple ",descripcion:"Aprende a usar el present simple en diferentes contextos ",url:"https://drive.google.com/file/d/1uosvGKLwegu9ECo9TZTG3uJd79ku4_G2/view?usp=sharing",url2: "https://youtu.be/b5KxYRP2I5s",url3:"https://drive.google.com/file/d/19bs04pZ2WROkgtnCaKSEXxp4hB_Fk_qa/view?usp=sharing"},
            { titulo:"Usual",descripcion:"Aprende los diferentes usos del usual",codigo:"GRAMMARISPOWER",url: "https://drive.google.com/file/d/1Iru4Ttn7yf9vwOiUU8XjC6MCB9DPMHA8/view?usp=sharing",url2:"https://youtu.be/OSRAYauWH-I",url3:"https://drive.google.com/file/d/1sugjoNOr6dwEHogTwcKeYHUVbebEBbpX/view?usp=sharing"},
            { titulo:"Usually",codigo:"STICKTOUSUAL",url: "https://drive.google.com/file/d/1IPWIh1B7oYwV4aPRJJKnM-gpZICitsX_/view?usp=sharing",url2:"https://www.youtube.com/watch?v=nYxi8UCraJI&ab_channel=MyEnglishBro"},
            { titulo:"I think not vs I don't think so. ",url: "https://drive.google.com/file/d/15nnCB3JJRtH1fqqx5TypEptgoRbo5q-P/view?usp=sharing"},
            { titulo:"Enough and Too ",codigo:"WORKSFINE",url: "https://drive.google.com/file/d/1Tcadp5eOdfsHOlCwJWs0iNuphHQO4gYA/view?usp=sharing"},

            {  titulo:"Battle Code ",descripcion:"Las respuestas de cada pregunta son el código del siguiente nivel",url:"https://drive.google.com/file/d/19bs04pZ2WROkgtnCaKSEXxp4hB_Fk_qa/view?usp=sharing"},

        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Essential Grammar ",
        subtitle: "B2",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
        
            { titulo:"📚[Slide] Impersonal Passive/ Personal Passive  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},

            { titulo:"📚Amount ..Quantity ..Number  ",url: "https://drive.google.com/file/d/1CN4FalpOZBZ-SMMcatuxD_uasMzenrDA/view?usp=sharing"},
            { titulo:"📚apart from, aside from, except for  ",url: "https://drive.google.com/file/d/1EEftSd6UjyKcnVoP77VJFglfxUw_7gng/view?usp=sharing"},
            { titulo:"📚Aren't I vs Am I not ",url: "https://drive.google.com/file/d/1DKuTnhQurzBMHVo0P0GLL_EdI3y8LMvs/view?usp=sharing"},
            { titulo:"📚AS...AS... vs NOT SO...AS..",url: "https://drive.google.com/file/d/1VLCJlD5Tgn9XU3oUo05emwf23WkT5XQ8/view?usp=sharing"},
            { titulo:"📚Future Plans- be going to vs present continuous",url: "https://drive.google.com/file/d/1Ov96Gz7ZEr3wDsnwDXF15q-6C8TrAPts/view?usp=sharing"},
            { titulo:"📚by the time (that), by now, by then.",url: "https://drive.google.com/file/d/1VQxnXCmbei5cxZucSW8FJKBOdgMQGRmO/view?usp=sharing"},
            { titulo:"📚cannot vs can not",url: "https://drive.google.com/file/d/1CXcCzrtdDif6iBEi75d_9CFxIE6847Q4/view?usp=sharing"},
            { titulo:"📚CAUSATIVE VERBS (have - get) ",url: "https://drive.google.com/file/d/1-PErCarKwe61HtSAbgx2wtJapHkBM9bp/view?usp=sharing"},
            { titulo:"📚Table CAUSATIVE VERBS (have - get) ",url: "https://drive.google.com/file/d/1NoE0tUIpAlHgGNHc1xBIi_YFIyoBax15/view?usp=sharing"},
            { titulo:"📚CLEFT SENTENCES (TABLE) ",url: "https://drive.google.com/file/d/13-JhSbUYrCntdTi5t097wDYyeUmJH-g1/view?usp=sharing"},
            { titulo:"📚Consist in vs Consist of.. ",url: "https://drive.google.com/file/d/1F-XK5pIbsWwlOIDU-XfXpEVATQdlTggq/view?usp=sharing"},
            { titulo:"📚CORRELATIVE CONJUNCTIONS",url: "https://drive.google.com/file/d/16ud5EPb-q127g3tRlHKoV_Pk5HKpLoh8/view?usp=sharing"},
            { titulo:"📚DECISIONS, PLANS, PREDICTIONS",url: "https://drive.google.com/file/d/1LirHWCiSSatbjAv8q1ItdX32fnY2Tk8c/view?usp=sharing"},
            { titulo:"📚didn't need to vs needn't have done..",url: "https://drive.google.com/file/d/134MeLLR89v9--eCmh35fZ7FnQsbra8lT/view?usp=sharing"},
            { titulo:"📚Direct & Indirect speech (table) + kwt exercises",url: "https://drive.google.com/file/d/1rBQWS8z17BGn4B2mT0SGJt6J5CHEyZkw/view?usp=sharing"},
            { titulo:"📚do you mind  would you mind",url: "https://drive.google.com/file/d/1qUomEVgJdczYHV59Z_JCNTCSfQZ0Md9W/view?usp=sharing"},
            { titulo:"📚Early vs Soon ",url: "https://drive.google.com/file/d/1Acdy7DKjKxgj_6sWY4adIxRH9u5v-6bj/view?usp=sharing"},
            { titulo:"📚Either ...or  vs OR ",url: "https://drive.google.com/file/d/1DD4Z1gKhaIB3WK1wBB2aH1gk1bVglPhI/view?usp=sharing"},
            { titulo:"📚EVEN though-when-if-so ",url: "https://drive.google.com/file/d/1K5b3KQrgOSpO_5gfqRTbf7UEVFHuGrob/view?usp=sharing"},
            { titulo:"📚WHAT and HOW (Exclamations) ",url: "https://drive.google.com/file/d/1OJI6_nCQEgh26dLzcN0Lta-I5Ln202Oq/view?usp=sharing"},
            { titulo:"📚Expressing lack of surprise (phrases).. ",url: "https://drive.google.com/file/d/10OCN5p9pht9TviKo5C8Tlpq65n7LFSzV/view?usp=sharing"},
            { titulo:"📚EXPRESSING PURPOSE-- ",url: "https://drive.google.com/file/d/1aRymKDEhwoQRppVdi-ztAThEOAOp0JMe/view?usp=sharing"},
            { titulo:"📚Expressing willingness (Will and Would ) ",url: "https://drive.google.com/file/d/1AJr_SKwGzajEuvqdC72Mumc0DVJZwag0/view?usp=sharing"},
            { titulo:"📚Few vs Little Full Explanation",url: "https://drive.google.com/file/d/1aBJdWZnhLdBVlvxlBl3hb_-0tac67XUw/view?usp=sharing"},
            { titulo:"📚FOR + ING vs TO+ INFINITIVE",url: "https://drive.google.com/file/d/1rX-n7tp2oviaCzq6QjiSlBe4jZlTW2y5/view?usp=sharing"},
            { titulo:"📚FOR...TO",url: "https://drive.google.com/file/d/17TmzNhbfrrhN344SE_TnKDMo0Jip1-b5/view?usp=sharing"},
            { titulo:"📚FUTURE CONTINUOUS",url: "https://drive.google.com/file/d/1CHKDeg9dOgpCRuGliPUKMI0vUI-ccZlK/view?usp=sharing"},
            { titulo:"📚had better",url: "https://drive.google.com/file/d/1HJEWIQQrKUc3ZeI0tQUVOz9Uq3ooXY6_/view?usp=sharing"},
            { titulo:"📚having a lot to do",url: "https://drive.google.com/file/d/1LiGCvmom_wRtwvNbKXx3WhALIglfBsgS/view?usp=sharing"},
            { titulo:"📚I wish he were vs I wish he was. ",url: "https://drive.google.com/file/d/1fbiunfDO3ATtUfhVjJmYTVaiIl7wuHUM/view?usp=sharing"},
            { titulo:"📚wish you didn't - wish you wouldn't",url: "https://drive.google.com/file/d/1c_W6Rnvb2guEvvGvtz4UpXOXt-oowWLm/view?usp=sharing"},
            { titulo:"📚If I were vs If I was ",url: "https://drive.google.com/file/d/1L8gL4in7HNGsjw_fqgsCzi2FPNi3VYR8/view?usp=sharing"},
           
            { titulo:"📚INCLUDING OR OMITTING RELATIVE PRONOUNS ",url: "https://drive.google.com/file/d/1Ewn06vQoRRM7-ObSlsWbRMMgY937yU6o/view?usp=sharing"},
            { titulo:"📚INVERSIONS AT B2 LEVEL..pdf ",url: "https://drive.google.com/file/d/17DCJanovoUIB6Vome6kfXe4kMRVo24Cc/view?usp=sharing"},
            { titulo:"📚INVERSION - NEITHER and NOR..pdf ",url: "https://drive.google.com/file/d/1WPJd9-AcEd7p7uvD6IMT1LLVgh0c6JrO/view?usp=sharing"},
            { titulo:"📚Irregular verbs that stay the same.pdf ",url: "https://drive.google.com/file/d/1lXnJki--FsJONo7pe-kcyTrP_ULPrPGq/view?usp=sharing"},
            { titulo:"📚it's (about-high) time ",url: "https://drive.google.com/file/d/1JsV99-95VmCWYE-ueZxQOT-2X7G8F-WJ/view?usp=sharing"},
            { titulo:"📚it is you who is or are.pdf ",url: "https://drive.google.com/file/d/1BndKeJOOstmHCB7pUYxQQyLr-YhfcSPJ/view?usp=sharing"},
            { titulo:"📚JOINING NEGATIVE IDEAS.pdf ",url: "https://drive.google.com/file/d/1OuDSE00YChqB4_W8nCFT7R2DTWt5ZfLF/view?usp=sharing"},
            








          
            { titulo:"📚Personal and Impersonal Passive",url: "https://drive.google.com/file/d/1obtVtl8UEAVz9UCz4aff_q7WGGYwDim2/view?usp=sharing"},
            { titulo:"📚PREFER (structures)",url: "https://drive.google.com/file/d/1K1snnmMtNgzLZOuyZ5HQR62_5MWh4_kt/view?usp=sharing"},
            { titulo:"📚Prepare for, Prepare oneself for",url: "https://drive.google.com/file/d/1tG9gKZJ_jzgMHZZC2H5oqGvrf78UxRCU/view?usp=sharing"},
            { titulo:"📚present habits",url: "https://drive.google.com/file/d/1qoaInxhVWNQsxI354IL8Cj3ho7iHjCQ7/view?usp=sharing"},
       
       
            { titulo:"📚QUANTIFIERS",url: "https://drive.google.com/file/d/1iGVwAqosK0wGZ216J_rgHXVnuVnLBZLM/view?usp=sharing"},
            { titulo:"📚Universal Tags",url: "https://drive.google.com/file/d/1N2ZdcMbCQ_JEZEgXXsZ7QEjyhjgN2sjY/view?usp=sharing"},
            { titulo:"📚QUESTION TAG - HAVE",url: "https://drive.google.com/file/d/1TfK9qlZtV5D3m1PFQ98IpYTLV8G9RSTM/view?usp=sharing"},


           
            { titulo:"📚statement tags",url: "https://drive.google.com/file/d/1wPLJc7cxDP6KjIphJKOf5yDgy6PKGqQA/view?usp=sharing"},
           


            
         
            { titulo:"📚Words with Silent Letters",url: "https://drive.google.com/file/d/1eAPZFyNImLFcuMVSfvWhfJgUPj4f78jO/view?usp=sharing"},
            { titulo:"📚SINGULAR THEY",url: "https://drive.google.com/file/d/1xAT_pnOmVjImRxmr1LX57yWLdWbKGVf4/view?usp=sharing"},
            { titulo:"📚so+adj+that vs so+adj+as to",url: "https://drive.google.com/file/d/1Dox44XMlIjIJkzhUO1-wjetHjtfbn13Q/view?usp=sharing"},

            { titulo:"📚take for, mistake for, confuse with",url: "https://drive.google.com/file/d/19Vprq7R-KXX0JVHNjK5p9et5eLlAduJ-/view?usp=sharing"},




         
        
            { titulo:"📚Universal Tags--.pdf",url: "https://drive.google.com/file/d/1OSz1iN5iCyX05MS1x0HLVUt93kuQUKKa/view?usp=sharing"},
            { titulo:"📚[Slide] Useful Homophones ",url: "https://drive.google.com/file/d/1MWO2XHuHp0bAzFceREIteP_cKXyuwe1j/view?usp=sharing"},
            { titulo:"📚Verbs followed by infinitive or gerund with change in meaning ",url: "https://drive.google.com/file/d/1-zILhE9-k1jSvyi5Rx5u6G_mRR_cpXxa/view?usp=sharing"},
            { titulo:"📚IF vs WHETHER.pdf",url: "https://drive.google.com/file/d/1K8SHYnfmfuU7V8MBw2IGBot7wk1VO0hb/view?usp=sharing"},
            { titulo:"📚[Slide] Would rather/Would Sooner ",url: "https://drive.google.com/file/d/1F-t7qwMfcb5PDKfFodN02qZFwCzIZFqu/view?usp=sharing"},
            { titulo:"📚You and me vs You and I.pdf",url: "https://drive.google.com/file/d/1HQvOU9nI4uYstFx3AndBDY2Krj7C1cso/view?usp=sharing"},
            { titulo:"📚Zero article vs definite article (locations).pdf",url: "https://drive.google.com/file/d/1C1ia0DWTYVI0wI-aZS3CGf2oEuLwmwyk/view?usp=sharing"},

        ],
    },
   
    {
        id: 2,
        thumbnail: "https://i.ibb.co/ns4nywn7/DALL-E-2025-03-13-12-50-42-A-formidable-warrior-representing-the-Present-Progressive-tense-in-Englis.webp",
        code:"secrevpouthealou",
        reconpensa: "https://i.ibb.co/jkkK0wXX/RECONPENSAPRESENTSIMPLE.webp",
        reconpensaDescripcion: "La Espada Legendaria ‘Routine & Facts’ resplandece con un aura mística, irradiando la esencia misma del Present Simple. Su hoja afilada y resplandeciente está grabada con inscripciones que representan la estructura inquebrantable de este tiempo verbal ⚔️✨",
        title: "Present Progressive",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [

          { titulo:"🎬 Present Progressive Usos",url:"https://drive.google.com/file/d/15m5KpSZhu7Q1vop2-MiqlARFmY8jLx9u/view?usp=sharing",url2: "https://youtu.be/Nnu6JOaenf0"},
          { titulo:"📚Doubt that vs Doubt if",url: "https://drive.google.com/file/d/1qEgnOfM7BoFG1lmMu_xWgNbRlwBTt9X2/view?usp=sharing"},
          { titulo:"📚[Slide] The fact that  ",url: "https://drive.google.com/file/d/1FSd3Vt3C71C0kujDoy4egxFDy8_ZugZv/view?usp=sharing"},
          { titulo:"📚the same as - the same that.pdf",url: "https://drive.google.com/file/d/1XxkdYtKE6YyMH3jP93Aog9mXF_l9wu9l/view?usp=sharing"},


        ],
    },
    {
        id: 3,
        thumbnail: "https://i.ibb.co/RxW0zs8/DALL-E-2025-03-14-09-59-57-An-intense-battlefield-where-students-have-fought-against-the-powerful-wa.webp",

        title: "Present Simple or Progressive ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
           
            
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/19FdH7nnsqL0Ez9siyiFv3PCEvt4EknFv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HRBxbp2b_5kcObTcgjMDmRKXH-xW0O4M/view?usp=sharing", },
          
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1aAeXIW3wmnJwJjUTcCE6m7PV9aElcgeB/view?usp=sharing", },
            { titulo: "✍ FORM Tense Simple and Progressive ",url: "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAN__5DYD2BUMEJFTFdHTTM3V0gzREowUlJRUVkwSjBaVC4u", },

            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1ugupTJWoGVpoH7q_UxAivmklT21IBsKv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HlMPxx9G-eXDvAkpnoYcD_qhH8DRcUt_/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1fQ23Xn4bXCSZJSaHGiWf5utUXeHAK0ma/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Gjn3DIa6xRDKcbKFvUopOvzMTA7vnW02/view?usp=sharing",url3:"https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZAAPF2C5FUMTJFMU5UQ09VTkRXS09HREs3VVdWMk8zSy4u" },


            


        ],
    },
   
    {
        id: 5,
        thumbnail: "https://i.ibb.co/4CTCgND/DALL-E-2025-03-03-10-24-24-A-high-quality-digital-illustration-of-a-young-warrior-student-battling-t.webp",
        reconpensa: "https://i.ibb.co/jkkK0wXX/RECONPENSAPRESENTSIMPLE.webp",
       reconpensaDescripcion: "La Espada Legendaria ‘Routine & Facts’ resplandece con un aura mística, irradiando la esencia misma del Present Simple. Su hoja afilada y resplandeciente está grabada con inscripciones que representan la estructura inquebrantable de este tiempo verbal ⚔️✨",

        title: "Test Center",
        subtitle: "B2/C1",
        code:"iolasa",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo:"Solucionario Codigo",url: "https://drive.google.com/file/d/1h_GmZKkaqKgs3BGwUmpQWsf631u2MnFs/view?usp=sharing"},

            { titulo:"Examen Saxon genitive",url: "https://drive.google.com/file/d/1lauthcKfiGkFEhUQMq3hjpQlJAvBfl1n/view?usp=sharing"},
            { titulo:"Examen de Interpretacion",url: "https://drive.google.com/file/d/1ZlLgABkb88_3qDLHlrTYOpHCUCTouVbz/view?usp=sharing"},
        ],
    },
    {
        id: 5,
        thumbnail: "https://i.ibb.co/vCS8bknP/DALL-E-2025-03-14-10-37-22-A-formidable-warrior-representing-the-challenge-of-mastering-English-voca.webp",

        title: "Vocabulary",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo:"List 01",url: "https://drive.google.com/file/d/1eGDk_XRymJiQx1EQdQ1VrrD-g-LKqAtT/view?usp=sharing"},
            { titulo:"List 02",url: "https://drive.google.com/file/d/1p3CZYooGPIALtdYjYo6VgInqBclmhh3m/view?usp=sharing"},
            { titulo:"List 03",url: "https://drive.google.com/file/d/1p29O7AwJXBxjKOR8CeRaeNTpISGO6-TC/view?usp=sharing"},
            { titulo:"List 04",url: "https://drive.google.com/file/d/16BMsrHXCXLo3A2pHD3_B8e5_aI5BdU_l/view?usp=sharing"},
            { titulo:"List 05",url: "https://drive.google.com/file/d/14Zc_IKDm1_Up-ByUsJH8fHWZRVEWMTYj/view?usp=sharing"},


        ],
    },
    {
        id: 6,
        thumbnail: "https://i.ibb.co/v6T66Y2g/DALL-E-2025-02-26-11-53-11-A-dramatic-battle-between-two-warriors-representing-Past-Simple-and-Prese.webp",

        title: "Past Simple or Present Perfect?",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"[📑 Past Simple", url: "https://drive.google.com/file/d/19wgEn7E6c-hBR1q08aSUU7ibHn8ERRl-/view?usp=sharing"},
            {  titulo:"[📑 Present Perfect", url: "https://drive.google.com/file/d/11x2FcIbUKSvFsAm2PyyfTOQ5zyYXE92i/view?usp=sharing"},

            {  titulo:"[📑 Present Perfect Progressive", url: "https://drive.google.com/file/d/1CoGNeh_2_0CkmXYzSkwugtCx185XJUp-/view?usp=sharing"},

            { titulo: "✍ Past Simple and Present Perfect (Simple and Progressive) ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },    
            { titulo: "✍ Past and Present Perfect Simple ",url: "https://drive.google.com/file/d/1Ngj2Ivf2Y8ak8QxCHo8QfLyTAOft-Qx0/view?usp=sharing", },
            { titulo: "✍ Past and Present Perfect Simple ",url: "https://drive.google.com/file/d/1D6keuz7pTkAnNv7mr2WRWoNIIlR5xaAu/view?usp=sharing", },
            { titulo: "✍ Letter to Janet - Past and Present Perfect Tense ",url: "https://drive.google.com/file/d/1gVcDYVZYAmhQQeKJPjDVnX9a49qiLyR5/view?usp=sharing", },
           

            
        ],
    },
    {
        id: 3,
        thumbnail: "https://i.ibb.co/chjzRzhM/DALL-E-2025-03-03-10-26-54-A-high-quality-digital-illustration-of-a-young-warrior-student-advancing.webp",

        title: "Week 02",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo:"However vs Nevertheless  ",url: "https://drive.google.com/file/d/17HG1wBQ5zHdOzYjHMGitv20kmvUm4cQ3/view?usp=sharing"},
            { titulo:"However vs Nevertheless 2  ",url: "https://drive.google.com/file/d/1Lg28Wbr5irTlfxbhDk-NQdQJf24Y0Tgz/view?usp=sharing"},

            { titulo:"on the one / other hand  ",url: "https://drive.google.com/file/d/1dB853cQmDq5i5K708OZKgwwO0_rEBaPQ/view?usp=sharing"},
            { titulo:"When it comes to   ",url: "https://drive.google.com/file/d/1lHB4gZng8Xl_ZCHbHyILcPI-yzbH_ErB/view?usp=sharing"},
            { titulo:"to what extent  ",url: "https://drive.google.com/file/d/1RMz56tFmTkfh08F8dWitdr0mT47hWP-e/view?usp=sharing"},

            { titulo:"📚already/still/yet  ",url: "https://drive.google.com/file/d/126LmouA8outgNhw5x6wUcZI3F4tT1v4j/view?usp=sharing"},

            { titulo:"📚Among vs Between",url: "https://drive.google.com/file/d/1cpk7V_8qdxoX8VUpZYRT5zq_9GrCoWzc/view?usp=sharing",url3:"https://drive.google.com/file/d/1oL-Hu8nnXahjVI0gUZlN7YZWqVw5bkBC/view?usp=sharing"},

            { titulo:"📚between you and me vs between you and I",url: "https://drive.google.com/file/d/1cpk7V_8qdxoX8VUpZYRT5zq_9GrCoWzc/view?usp=sharing",url3:"https://drive.google.com/file/d/1oL-Hu8nnXahjVI0gUZlN7YZWqVw5bkBC/view?usp=sharing"},
            { titulo:" Common Binomials",url: "https://drive.google.com/file/d/1LgAKdAj0ftr1PIN46d4aAdBLuiyEdaPl/view?usp=sharing", url3:"https://drive.google.com/file/d/1Tg8SJHCNLodO3LwoMm8Y0qepMvDzUNMh/view?usp=sharing"},
            { titulo:"Be up TO & FOR",url: "https://drive.google.com/file/d/1xzD1SJQbZJ1aAxkM0jljNOAE2tPD_FYz/view?usp=sharing"},
        ],
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/4CTCgND/DALL-E-2025-03-03-10-24-24-A-high-quality-digital-illustration-of-a-young-warrior-student-battling-t.webp",

        title: "Test Center 02",
        subtitle: "B2/C1",
        code:"iolasa",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo:"Solucionario Codigo",url: "https://drive.google.com/file/d/1h_GmZKkaqKgs3BGwUmpQWsf631u2MnFs/view?usp=sharing"},

            { titulo:"Examen Saxon genitive",url: "https://drive.google.com/file/d/1lauthcKfiGkFEhUQMq3hjpQlJAvBfl1n/view?usp=sharing"},
            { titulo:"Examen de Interpretacion",url: "https://drive.google.com/file/d/1ZlLgABkb88_3qDLHlrTYOpHCUCTouVbz/view?usp=sharing"},
        ],
    },

   
    {
        id: 2,
        code:"newpastp",
        thumbnail:
            "https://i.ibb.co/6JrNL8Js/DALL-E-2025-02-27-11-08-55-A-surreal-battlefield-where-students-are-fighting-against-English-grammar.webp",
        title: "Essential Vocabulary  ",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
           
          
            {  titulo:" Bloque 01 ", url: "https://drive.google.com/file/d/1S8x1T_F486L1hYbyPdTeL4rvx-uQXGEt/view?usp=sharing  "},

            {  titulo:" Bloque 02 ", url: " https://drive.google.com/file/d/1CA7Ub9WI-QKTBXhZI2S6yBrQV5gez1Jy/view?usp=sharing "},
            {  titulo:" Bloque 03 ", url: " https://drive.google.com/file/d/1ETAjorHO8WFszYjEi6b_G6e8FM4i6y6N/view?usp=sharing "},
            {  titulo:" Bloque 04 ", url: " https://drive.google.com/file/d/1uvJn25j4BA2gtkdvJZ5qvdY9GZs9Th0_/view?usp=sharing "},



        ],
    },
    {
        id: 3,
        thumbnail:
            "https://i.ibb.co/XftB6PSR/DALL-E-2025-02-27-11-10-10-A-surreal-and-dynamic-scene-of-students-leveling-up-and-gaining-power-in.webp",
        title: "Grammar Syntax ",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
           
            {  titulo:"[📑 Tense ss ", url: "https://drive.google.com/file/d/1ZY4xjMU2sMSNZSq9jme_78W2QEQiMKQX/view?usp=sharing"},


         
           
        ],
    },
    {
        id: 0,
        thumbnail: "https://i.ibb.co/B2pxp5ZR/DALL-E-2025-02-26-11-55-47-A-powerful-warrior-representing-the-Present-Simple-tense-He-wears-a-class.webp",

        title: "Present Simple",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
           
            { titulo:"🎬 Introduccion ",url: "https://youtu.be/C9jsb_4RVyE"},
            { titulo:"🎬 Present Progressive Uso 01",url: "https://youtu.be/vKi-SGeme-w"},
            {  titulo:"[📑 Present Progressive en Uso", url: "https://drive.google.com/file/d/15m5KpSZhu7Q1vop2-MiqlARFmY8jLx9u/view?usp=sharing"},
            {  titulo:"[📑 Present Simple en Uso", url: "https://drive.google.com/file/d/1uosvGKLwegu9ECo9TZTG3uJd79ku4_G2/view?usp=sharing"},
          


            


        ],
    },
    {
        id: 0,
        thumbnail: "https://i.ibb.co/B2pxp5ZR/DALL-E-2025-02-26-11-55-47-A-powerful-warrior-representing-the-Present-Simple-tense-He-wears-a-class.webp",

        title: "Present Progressive",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
           
            { titulo:"🎬 Introduccion ",url: "https://youtu.be/C9jsb_4RVyE"},
            { titulo:"🎬 Present Progressive Uso 01",url: "https://youtu.be/vKi-SGeme-w"},
            {  titulo:"[📑 Present Progressive en Uso", url: "https://drive.google.com/file/d/15m5KpSZhu7Q1vop2-MiqlARFmY8jLx9u/view?usp=sharing"},
            {  titulo:"[📑 Present Simple en Uso", url: "https://drive.google.com/file/d/1uosvGKLwegu9ECo9TZTG3uJd79ku4_G2/view?usp=sharing"},
          


            


        ],
    },
  
    {
        id: 22,
        thumbnail: "https://i.ibb.co/4npzrRYN/DALL-E-2025-02-26-11-50-46-An-intense-battle-between-two-warriors-representing-Past-Simple-and-Past.webp",

        title: "Past Simple or Progressive?",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/18h8QAkzm5UIzr-TF3DywBw_F-KtkjUYY/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1LCS98Vmh3gzPntxzCx5kX_EdackIK0v_/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1gxGscWmK3hDwJTXbNQpUEKlWSh_J9VLG/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1_3IiO9AC-y6Ks5RZujHdQyaWKKeMO9pu/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Cc3RqGtZefUPxDSohH0Xssr4OSO5uftZ/view?usp=sharing", },
        ],
    },
     
    
    {
        id: 0,
        thumbnail:"https://i.ibb.co/C3pnhgt6/file-N3-Gw1-XXR7w-Wr-Wom-Bj-Xy-Mgg.png",
        title: "IELTS Band 6 ",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
           
                { "titulo": "[🖥️Class]  day 10", "url": "https://youtu.be/vOFnYJj2YDw?si=97D43xFvTa5T62Ki" },
                { "titulo": "[🖥️Class]  day 09", "url": "https://youtu.be/b6djjYxzL2E?si=oi_jE9U0HIGCTQPO" },
                { "titulo": "[🖥️Class]  DAY 07-08", "url": "https://youtu.be/1mtFYWdDKRk?si=-AYtTZEFO5J6cde0" },
                { "titulo": "[🖥️Class]  day 6", "url": "https://youtu.be/QCqUi-A0aFo?si=Nq1-DkvbDPf-5kzW" },

                { "titulo": "[🖥️Class]  day 3-4-5", "url": "https://youtu.be/0j8cXsFRvjU?si=qspyfEdp9ckn4KA4" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://youtu.be/e413NPHCLzk?si=qMuNrow1upMvf3Xz" },

              
            ],
            
    },
   
   
   
    // {
    //     id: 2,
    //     thumbnail:"https://i.ibb.co/b53R08DX/file-BEBHv-Yhkgbs-E4pxzmsb5-Sd.png",
    //     title: "Phrasal Verbs in use 02",
    //     subtitle: "B2/C1",

    //     dateAdded: "Week 01 ",
    //     channel: "sdasd",
    //     description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
    //     enlaces: [
           
    //     ],
    // },
    // {
    //     id: 2,
    //     thumbnail:"https://i.ibb.co/b53R08DX/file-BEBHv-Yhkgbs-E4pxzmsb5-Sd.png",
    //     title: "Phrasal Verbs in use 03",
    //     subtitle: "B2/C1",

    //     dateAdded: "Week 01 ",
    //     channel: "sdasd",
    //     description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
    //     enlaces: [
           
    //     ],
    // },
   
    {
        id: 15,
        thumbnail:"https://i.ibb.co/5WQ17W7D/file-Fg6-EG7bvr-Nig-Ee3-S7m-XCfd.png",

        title: "Writing",
        subtitle: "B2/C1",

        dateAdded: "B2",
        channel: "sdasd",
        description: "Aprende técnicas literarias avanzadas para enriquecer tu escritura y expresión creativa en inglés",
        enlaces: [
            {
                titulo: "📃 Article  B2 Model",
                url: "https://drive.google.com/file/d/1U8-YHSgp_xeZDvbmty19W-fevEden95O/view?usp=sharing",
            },
            {
                titulo: "📃 Report  B2 Model",
                url: "https://drive.google.com/file/d/1_z4lgav_LheAS_ep8UEw4qcoz1SnI-XT/view?usp=sharing",
            },
            {
                titulo: "📃 Email  B2 Model",
                url: "https://drive.google.com/file/d/14Sb5Q_2-XOevWNgGqLaWyBDHGF3iX-DG/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Essay  B2 Model",
                url: "https://drive.google.com/file/d/1shuKn4-Sgu3VW2SqO1Gbv4a3BNUjFWB0/view?usp=sharing",
            }, {
                titulo: "📃[pdf] Essay  B2 Model 2",
                url: "https://drive.google.com/file/d/1A3zKsg5My6XQlKxWRNiCoM_Jh5Wwepvp/view?usp=sharing",
            }
            ,
            {
                titulo: "📃[pdf] C1 Template Essay 2025",
                url: "https://drive.google.com/file/d/1ELdPTtS6V33-pBtJr2uRSizlrfuCH4nB/view?usp=sharing",
            },
            {
                titulo: "📃[pdf]Useful Language",
                url: "https://drive.google.com/file/d/1gMBSe_vvMgQq-IkIQtpDydmpuKq_YiMa/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Amazing Template Essay 2025",
                url: "https://drive.google.com/file/d/1GTnhTS-RWFKpJ2Q9DRhBOxb-IqgjIjmZ/view?usp=sharing",
            }
            ,
            {
                titulo: "📃[pdf] Writing Templates",
                url: "https://docs.google.com/document/d/1ynAsrV2Uj-uR0qrCDzGvDw8I2sXYlzEg/edit?rtpof=true&sd=true",
            },
            {
                titulo: "📃[pdf] How to write an Essay",
                url: "https://docs.google.com/presentation/d/1ulmNP0wMeqUi-ZlMpg6ngsCi_jjX9nBn/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },{
                titulo: "📃[ppt] Advanced Transitions",
                url: "https://docs.google.com/presentation/d/1fGnuhWtExMKny18ZqasLeugnXi9cb9pU/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },{
                titulo: "📃[Inf] Writing Mistakes everyone makes",
                url: "https://drive.google.com/file/d/17vYjDTq69ecevpRtiD1mSOevKqFLrOSM/view?usp=sharing",
            },
            
        ],
    },
    
   
    {
        id: 0,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",
        title: "Recordings 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
           
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=gGWtrDuoUi0" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?si=MHjaEN7bzBy3ZOhc&v=9bB9PgyB_bg&feature=youtu.be" },
                { "titulo": "[🖥️Class]  after", "url": "https://www.youtube.com/watch?v=5ilyP5xsyes&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?si=m4xdSF6v23GibP_H&v=CR6rnB5Yg0Y&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?si=tixxZisScjmyyLzI&v=eOtsLBuwvgw&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?si=dYFzG1VF98Tqkvyi&v=I5E5Q3yByPs&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 6", "url": "https://www.youtube.com/watch?si=-KYzJRc2XtTsfytL&v=OuqZlRsw7NE&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 7", "url": "https://www.youtube.com/watch?v=4hyP05BgB9M&list=PLaYNhMsVRuHhY6xcwxg931ib5xCbw2zWC&index=8&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 8", "url": "https://www.youtube.com/watch?v=XE7dOWDGpek&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 9", "url": "https://www.youtube.com/watch?v=w2i-Q7YHpvc" },
                { "titulo": "[🖥️Class]  day 10", "url": "https://youtu.be/1yYDsB_X9Ow" },
                { "titulo": "[🖥️Class]  day 11", "url": "https://www.youtube.com/watch?v=G7noYDWA80I&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 12", "url": "https://youtu.be/96wYFY3lUh4" },
                { "titulo": "[🖥️Class]  day 13", "url": "https://www.youtube.com/watch?v=tVZPNUMq2d0&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 14", "url": "https://www.youtube.com/watch?v=RAY0LxAjNOk&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 15", "url": "https://www.youtube.com/watch?v=Czy1TEgGXu4&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 16", "url": "https://www.youtube.com/watch?v=NZjOZDjhK3E" },
                { "titulo": "[🖥️Class]  day 17", "url": "https://www.youtube.com/watch?v=gpbEMX4KPk8" },
                { "titulo": "[🖥️Class]  day 18", "url": "https://www.youtube.com/watch?v=ez9eoYxzU-A&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 19", "url": "https://youtu.be/t1njSOFuS84" },
                { "titulo": "[🖥️Class]  day 20", "url": "https://youtu.be/oNkeUNBrjG0" },
                { "titulo": "[🖥️Class]  day 21", "url": "https://youtu.be/MdL2xj330bk" },
                { "titulo": "[🖥️Class]  day 22", "url": "https://youtu.be/LYrMkpMS5RY" },
                { "titulo": "[🖥️Class]  day 23", "url": "https://youtu.be/iYdTP-7wvzc" },
                { "titulo": "[🖥️Class]  day 24", "url": "https://youtu.be/esjEITmf8Ug" },
                { "titulo": "[🖥️Class]  day 25", "url": "https://youtu.be/OxXnEdw-LdU" }
            ],
            
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",


        title: "Recordings 2025",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=R2TVluocgUg&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=kLjAWxOYZDI&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=_FJtW3NHYxQ&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=uSoQGya3n_Y&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=ccyWNJz7FS4&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=4&ab_channel=MyEnglishBro" },
                
            ],
            
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/PGdF1Pw/Dise-o-sin-t-tulo-7.png",

        title: "Recording IELTS 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=nIZcH0sQSf0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=1&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=C0RB86t1YIw&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=TV10GT7j_es&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=2ExYgxh9gjE&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=UEEEwLpO7z0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=4&ab_channel=MyEnglishBro" },
                
            ],
            
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: " English Expressions",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
           
                { "titulo": "Turn the Tables", "url": "https://www.youtube.com/watch?v=3BP1kSUR1f0&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&ab_channel=MyEnglishBro" },
                { "titulo": "Watch your Mouth", "url": "https://www.youtube.com/watch?v=_eriRuRfvvM&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "Spreading Rumors", "url": "https://www.youtube.com/watch?v=or0ZxUll78g&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "Yo me lo busqué", "url": "https://www.youtube.com/watch?v=lcmn32R7u4k&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=4&ab_channel=MyEnglishBro" },
                { "titulo": "Agarrarle el ritmo", "url": "https://www.youtube.com/watch?v=hHITyx_4An8&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "Empezar con el Pie Izquierdo", "url": "https://www.youtube.com/watch?v=oDkLrT8xRkg&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=6&ab_channel=MyEnglishBro" },
              
            ],
            
    },
    
    {
        id: 1,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Information",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
            { titulo:"📚[pdf] B2 First Speaking Overview  ",url: "https://drive.google.com/file/d/1QJ_hjTeJIBEb01q5q7L-UeVwwK2sW0Wg/view?usp=sharing"},
           
        ],
    },
   
 
    {
        id: 4,
        thumbnail:"https://i.ibb.co/vcMnX0n/B2-FIRST-17.png",

        title: "Cambridge Essentials",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"50 Key Word Transformation ",url: "https://drive.google.com/file/d/1shC9iwswMYoymUEiJ8H1s8b9ngvp8gdB/view?usp=sharing"},
            { titulo:"Mistakes in Writing ",url: "https://drive.google.com/file/d/1yiMC18Dxy5b5h-ve47g4SQT_wUOZ3yQX/view?usp=sharing"},
            { titulo:"Key Word Transformation Secrets",url: "https://drive.google.com/file/d/11XTF7rYH66kt5GauEs65M4zMiyfrOKAy/view?usp=sharing"},
            { titulo:"Reading Gap Secrets",url: "https://drive.google.com/file/d/1lNpyrE26v78RUX6T9VNWB3yvBuefKYoz/view?usp=sharing"},

         
        ],
    },
    {
        id: 4,
        thumbnail:"https://i.ibb.co/vcMnX0n/B2-FIRST-17.png",

        title: "Key Word Transformation",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"Presentación",url: "https://youtu.be/Hk1y2D9jbvQ"},
            { titulo:"50 Key Word Transformation ",url: "https://drive.google.com/file/d/1shC9iwswMYoymUEiJ8H1s8b9ngvp8gdB/view?usp=sharing"},

            { titulo:"Solución KWT 01 ",url: "https://youtu.be/muqLK--ykjg"},
            { titulo:"Test KWT 01 ",url: "https://drive.google.com/file/d/10cOoRCKkswKlwi2GOM4cvdOlWNBE-Hbx/view?usp=sharing"},
            { titulo:"Solución KWT 02 ",url: "https://youtu.be/7wrY5gW_Xco"},
            { titulo:"Test KWT 02 ",url: "https://drive.google.com/file/d/1VeU2a_peDOk2WMACF8anyG0GwLGZzOvM/view?usp=sharing"},
            { titulo:"Solución KWT 03 ",url: "https://youtu.be/D11X4WGnhuU"},
            { titulo:"Test KWT 03 ",url: "https://drive.google.com/file/d/1meGXse7csULGWCCAAOkANu1ckqn_bg5o/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 001 ",url: "https://drive.google.com/file/d/1fzxVyBLvMHRwzfHTGLgYapKOXasOXv0m/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 002 ",url: "https://drive.google.com/file/d/1AytA61HbBmJgFLcXNEwEBHJQjVelp1T3/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 003 ",url: "https://drive.google.com/file/d/1Kx3tL5lWNxOaeJwuu5bKqhaML8fi9nb6/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 004 ",url: "https://drive.google.com/file/d/1CkMzAwGVkwxbkDaLMAIaxo_cs3o4KADY/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 005 ",url: "https://drive.google.com/file/d/1qDQx3HJZL9Vkm6vOC9a-m7vUkqw4HMRa/view?usp=sharing"},

            { titulo:"📚 Key Word Transformation 28 ",url: "https://drive.google.com/file/d/10ct8FrtXch8uWcAuVeXoOw0h9aRZMm3f/view?usp=sharing"},
            { titulo:"📚 Key Word Transformation 29 ",url: "https://drive.google.com/file/d/1pTn7jQaGDjGHZ6LjXOUDpTy5j86W73BZ/view?usp=sharing"},
            { titulo:"📚 Key Word Transformation 30 ",url: "https://drive.google.com/file/d/1is1Fl-t-3IUPB31eclX1E6JpyyESoqtY/view?usp=sharing"},
            { titulo:"📚 Key Word Transformation 31 ",url: "https://drive.google.com/file/d/10vJ82iasNVDoCWiUomoA_zyp_NilAknA/view?usp=sharing"},
            { titulo:"📚 Key Word Transformation 32 ",url: "https://drive.google.com/file/d/1-92IEBQQcqQwK3LxDdLYmiAw0zaD6WGp/view?usp=sharing"},

        ],
    },
   
    
    
   
   
    
   
    
    {
        id: 13,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Speaking Center",
        subtitle: "B2/C1",
        color: "#8F2BBC",


        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Aprende a hablar como un hablante nativo enfocándote en la pronunciación, entonación y expresiones idiomáticas para mejorar tu fluidez y naturalidad al hablar.",
        enlaces: [
            {
                titulo: "🖥️[Video] Episodem  Website",
                url: "https://www.youtube.com/watch?v=9dt6WOuoXos",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 01",
                url: "https://drive.google.com/file/d/1QhvhLsCjF6V1BaYqpSd3cV9lgNuOCw_h/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 02",
                url: "https://drive.google.com/file/d/1h-s_T2_bFtZngCACYPMKw4U1V4mB6Ove/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 03",
                url: "https://drive.google.com/file/d/1vm6K2C5j061v2IneytvApO-r9tCdd3KS/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 04",
                url: "https://drive.google.com/file/d/1dGhBsbgRejXuovsdRie-bae23WpeY4V6/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 05",
                url: "https://drive.google.com/file/d/1ItqYXZB6Dc19PdmaB67E-9EZyAyfrl9y/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 01",
                url: "https://drive.google.com/file/d/1n-sf1L6DJZKdj0GSGV2zlPlaYI4WhJQ9/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 02",
                url: "https://drive.google.com/file/d/1Jiwqspyx05GE1Br1tTir8j-xWm1_-VbG/view?usp=sharing",
            },
            
            {
                titulo: "🎯[Activity] speaking Part 1",
                url: "https://wordwall.net/play/519/287/727",
            },
            {
                titulo: "📒[pdf] Linking Words | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1l7NLEB9G7uwaXkRONIKNJE7BjucKC_pC/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] 10 Preguntas de examen – Speaking Parte 1 (Entrevista) | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1Oe2kqUUQnetTzjYCcia8mx2IrPEurE92/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Explanation",
                url: "https://drive.google.com/file/d/1lQkT1_qz3fPUBqcysqdvxvi6bNtOmXab/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 1 - Useful Phrases",
                url: "https://drive.google.com/file/d/1Fty0C6H85HUHEJBG0KzAAOGK5a6FVMgz/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 2 - Useful Phrases",
                url: "https://drive.google.com/file/d/1vHp3IrV3Wiz1a2m8_GdbdIl3ITc4sf2e/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 3 - Useful Phrases",
                url: "https://drive.google.com/file/d/19HB0czJM2-XZZBuKr3FXHNAn8jP941DF/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 4 - Useful Phrases",
                url: "https://drive.google.com/file/d/1ZmLmEIS1vnRPbZD9D20vFkEJPpoE9jbm/view?usp=sharing",
            },
            {
                titulo: "📒Mistakes at First ",
                url: "https://drive.google.com/file/d/1GqRFqwYpNz2b52QJIJ9-RIGKOxkEV5HS/view?usp=sharing",
            }
            
            
        ],
    },
   
    {
        id: 14,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Listening Center",
        subtitle: "B2/C1",

        dateAdded: "B2/C1",
        channel: "sdasd",
        description: "Mejora tus habilidades de comprensión auditiva con este curso que te ayudará a entender a hablantes nativos en diferentes situaciones y acentos, fortaleciendo tu confianza al escuchar y comprender el idioma.",
        enlaces: [
            { titulo: "Listening Test 01", url: "https://drive.google.com/file/d/1D5AdAH1i9YgRKAPjt1hTCTFbZNSzb7mZ/view?usp=sharing" },
            { titulo: "Listening Test 02", url: "https://drive.google.com/file/d/15L0kGEMCnG64fOmwEyHI26fvKXDsRxjj/view?usp=sharing" },
            { titulo: "Listening Test 03", url: "https://drive.google.com/file/d/1MDFFBQWUYZIfHR1Sq8uh7NwUFeEbLabk/view?usp=sharing" },
            { titulo: "Listening Test 04", url: "https://drive.google.com/file/d/1XtMuAyPYc_eOO1ZM5xuPnKZlw8fci5MF/view?usp=sharing" },
            { titulo: "Listening Test 05", url: "https://drive.google.com/file/d/1gbY6fJBvFXn-L3qs_wgK_hvYCIhbfcWJ/view?usp=sharing" },
            { titulo: "Listening Test 06", url: "https://drive.google.com/file/d/1nmFFhMgNcZSmkpYe1PqHQ2lMeIdgghEQ/view?usp=sharing" },
            { titulo: "Listening Test 07", url: "https://drive.google.com/file/d/1C7B6D6Z_e-k9ugmEojOGuVtvmSHe2ojS/view?usp=sharing" },

            { titulo: "🦻Listening Trainer 01", url: "https://drive.google.com/file/d/1MKkEnM6ABu8UmYtqmWdG6wEFbPnNHwIq/view?usp=sharing" },
            { titulo: "🦻Listening B2 TEST 01", url: "https://drive.google.com/file/d/1zLZ9sYxQ9BLNEtLF391_VhItr8mrmCBX/view?usp=sharing" },

            {
                titulo: "🖥️[Video] Listening  Trainer 01",
                url: "https://drive.google.com/file/d/16rLz8vX-25nVKvO2y7_HIJ2j2Ay_-XL_/view?usp=sharing",
            }
            
    
        ],
    },
    
    {
        id: 15,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "M4 - English Verb Patterns",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "📒[slides] Transitive and Intransitive Verbs",url: "https://drive.google.com/file/d/1q9Ay8KRUU9tSwuHEvjIM8bKZ3PWCyjkZ/view?usp=sharing", },
            { titulo: "📒[slides] Gerunds and Infinitives Explanation",url: "https://drive.google.com/file/d/1rE08bQrEyF0TVO7FTYWGtLaiOGKuLjRO/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 1",url: "https://drive.google.com/file/d/1KJKLqjSwQeILyViRun9ADqge1ikKPmSD/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 2",url: "https://drive.google.com/file/d/19WY1c2LJZrAjj84niwx-u5dgh-dafQb6/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 3",url: "https://drive.google.com/file/d/1xURjjQPkur3dYBtFRuZTmbnqlC-ZCb2b/view?usp=sharing", },
            { titulo: "💡  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1H6BxX1OPZ-5fU7peCACnw6vRV5-lnUPW/view?usp=sharing", },
            { titulo: "🔑  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1OYpGW81Wt7dvLTsTa7zddJRJIKKo7Mpn/view?usp=sharing", },
            { titulo: "💡  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1GOe8JtMyfLpayGkIgkUn1IkGRblKsoGf/view?usp=sharing", },
            { titulo: "🔑  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1iAOBovzOkjJH9Z9rToPCj8losTuXz9ov/view?usp=sharing", },
            { titulo: "🧩  Desafio gerund vs infinitive",url: "https://wordwall.net/play/7240/772/7948", },
            { titulo: "🧩  Desafio gerund vs infinitive II",url: "https://wordwall.net/play/22920/270/462", },
            { titulo: "🧩  Desafio gerund vs infinitive III",url: "https://wordwall.net/play/76232/915/656", },
            { titulo: "🧩  Desafio gerund vs infinitive IV",url: "https://wordwall.net/play/71477/712/378", },
            { titulo: "🧩  Desafio gerund vs infinitive V",url: "https://wordwall.net/play/75464/667/869", },
            { titulo: "🧩  Desafio gerund vs infinitive VI ",url: "https://wordwall.net/play/59257/372/969", },
            { titulo: "🧩  Desafio gerund vs infinitive VII ",url: "https://wordwall.net/play/4838/285/4447", },

           
           



          
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },

            
        ],
    },
    {
        id: 18,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "M4 - Phrasal Verbs",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            


            {titulo: "📒Phrasal verb with Get",url: "https://drive.google.com/file/d/1txaA2U2EMDVKnJ--_UM8YhzDZBaHasDP/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Take",url: "https://drive.google.com/file/d/1ZkjaNFOku-6MgJSzH_QRRXHoYGm02uLQ/view?usp=sharing",},
            {titulo: "📒Phrasal verb Get vs Take",url: "https://drive.google.com/file/d/1XyP5ABzwxOESdOwnOucJ_2-3beKDqxwv/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Up",url: "https://drive.google.com/file/d/1B7kiX_3JXK8jiRYNFkR4IxPqoHCz0J7K/view?usp=sharing",},
            {titulo: "📒Phrasal verb Dictation",url: "https://drive.google.com/file/d/1Q78yaqJPpqUThoLZ4y5tqPFp-x6eCV8F/view?usp=sharing",},


         
            
            
        ],
    },
    {
        id: 19,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "M4 - Relative Clauses I",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Relative Clauses Explanation",url: "https://drive.google.com/file/d/1cxrD9paWOcm3w7pLDmE_WvAVi2FJQI1x/view?usp=sharing",},
            
            {titulo: "📒[slides] Defining Relative Clauses Exercise 1",url: "https://drive.google.com/file/d/1vLOQ-v7JohxwCcGIeIPZRB0VEIvE1P5b/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 1 key",url: "https://drive.google.com/file/d/1eUbQC4nby3BU4ob6iXnWLBgn1ucZtzGv/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 2",url: "https://drive.google.com/file/d/1zuEnn8IqoyVEFDGtioyJoAaF9beihzmL/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 2 key",url: "https://drive.google.com/file/d/1nAfUnBlJZYD6NAyXyrwcXyEGfEkGNMap/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 3",url: "https://drive.google.com/file/d/1JHS5Kog6HeXhj5GMgKY6GoafIv69Leoj/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 3 key",url: "https://drive.google.com/file/d/1g6Bcda-4oWQ_1ugTLgn-X2l4lAvRbmF2/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 4",url: "https://drive.google.com/file/d/1_yyKTGRy0f-fcCZ5BlRsMZXsBb2usP3g/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 4 key",url: "https://drive.google.com/file/d/1ug8Ybq084KuS4AMXVRJ76pN1rbYs93cA/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 1 ",url: "https://drive.google.com/file/d/1cFrsL8KTttdqE4BpsR2YGCU2BG_SrfSf/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 2 ",url: "https://drive.google.com/file/d/1HnZWwulcMoWRBuPlkGff-2xxJ9rX0x56/view?usp=sharing",},

            {titulo: "[Grammar Worksheet] WHOSE",url: "https://drive.google.com/file/d/10p5K6lvpYpdtEIhJNy-redgQ7aLBnVb2/view?usp=sharing",},

            {titulo: "[Grammar Quizz] Relative Clauses",url: "https://drive.google.com/file/d/1DqU2kvUjrAuTRfIzDQkpmleUANeWxnjP/view?usp=sharing",},
            {titulo: "[Grammar Quizz] WHO vs WHOSE",url: "https://drive.google.com/file/d/1Ab3XGgBtb8XhgPRFY-9K91ddlu_cEtpG/view?usp=sharing",},
            {titulo: "RC001 - Relative Clauses",url: "https://drive.google.com/file/d/1K8WkdJTAuJvGBwZcksUylm4xKDiC_efC/view?usp=sharing",},
            {titulo: "RC002 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1OFQyjqF7p2ppuJmqu76GnH3RlL4lkKzM/view?usp=sharing",},
            {titulo: "RC003 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1u24eoljpLI0AB8ROkDi-HSTenUlAubrj/view?usp=sharing",},
            {titulo: "RC004 - Relative Pronouns",url: "https://drive.google.com/file/d/19zQQNKYKQ3j81ooeAS7CLiG8klHE_2Qn/view?usp=sharing",},
            {titulo: "RC005 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1JwHY1cfaESrUMr9Dby2Gt21sxHRtZ5t6/view?usp=sharing",},
           

         
            
            
        ],
    },
   
    
   
    
   
    {
        id: 16,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Building Vocabulary",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            {  titulo:"📑 [Flash Cards] Fce Essential Words ",url: "https://quizlet.com/109647789/fce-vocabulary-flash-cards/?i=2oqoxh&x=1jqt"},
            {  titulo:"📑 [Game] Fce B2 First Prepositions ",url: "https://wordwall.net/play/39433/169/368"},

            {  titulo:"📑 [Anki Words] Necessary Words for Cambridge Exams ",url: "https://drive.google.com/file/d/1Nyh8Zhw0XGYZg-vFrNqpUT4oqNC0LozD/view"},
            {  titulo:"📑 [PDF] List of 200 Phrasal Verbs | B2 First (FCE) ",url: "https://docs.google.com/document/d/1kUtVFcyPfupiE32q77xJwfQ1afTjWB6nm39tZsNDoxI/edit"},
            {  titulo:"📑 [PDF] Collocation 01 | B2 First (FCE|CAE) ",url: "https://drive.google.com/file/d/1dFsaNG_Ln6tt29-fHuf-L22ktIRxnBjf/view?usp=sharing"},
            {  titulo:"📑 [App] Dictionary ",url: "https://www.mediafire.com/file/zofkpkpcylqtpfp/MacMillanED_2nd_Edition.rar/file"},
            {  titulo:"📑 [PDF] Answer Sheet ",url: "https://drive.google.com/file/d/16srt09bwR_CaPRNKel7WfErJSVqTyXl4/view?usp=sharing"},

            {  titulo:"📑 [PDF] Prepositions After Verbs & Adjectives ",url: "https://docs.google.com/document/d/1CeVFrtcUUUYYfBOyHIvXkZ0mUjl3vx7ri-L0BYkARd8/edit#heading=h.te6z9i49xc6a"},

        ],
    },
    {
        id: 17,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Inglés con Anime",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            {  titulo:"🎥[Video] Aprende inglés con Dragon Ball Z - Conversaciones ",url: "https://drive.google.com/file/d/1wBA_z3emPwA8_7zG4PTh_3eM9kIrsw_G/view?usp=sharing"},
            {  titulo:"🎥[Video]  Picoro entrena a Gohan ",url: "https://drive.google.com/file/d/1cSJBlQ_0_N-hLgm4A-g-wNnv9U9x1lJZ/view?usp=sharing"},
            {  titulo:"🎥 [Video] Ingles con Naruto ",url: "https://drive.google.com/file/d/1olidUMObF_HhIZ0BMJGQrRpZERjm-euc/view?usp=sharing"},
            {  titulo:"🎥 [Video] El sacrificio de Vegeta ",url: "https://youtu.be/ce1JkqjXKJ4"},
            {  titulo:"🎥 [Video] Useful Expressions Death Note ",url: "https://youtu.be/MTaLzZikzv4"},
            {  titulo:"🎥 [Video] Useful Expressions One Punch Man ",url: "https://youtu.be/n_DcqiFayc4"},
            {  titulo:"🎥 [Video] La fusion de Vegito ",url: "https://youtu.be/ma7q6esT3cg"},
            {  titulo:"🎥 [Video] Useful Expression My hero Academy ",url: "https://youtu.be/8sPqgQlfKsQ"},
            {  titulo:"🎥 [Video] Useful Expression Goku enseña la tecnica de la Fusion ",url: "https://youtu.be/S5yooa_kHDY"},


        ],
    }, {
        id: 18,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Exámenes Center",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"📝 Examen 01  ",url: "https://drive.google.com/file/d/1Sk4W7Ax3Ao9ZqGR4sVY4IFik3Jq6BQ_N/view?usp=sharing"},
            {  titulo:"📝 Examen 01 Solucionario ",url: "https://drive.google.com/file/d/13NnSnUDD8m95_AryEwZ5hMnfdxKYrQKV/view?usp=sharing"},

            {  titulo:"📝[Test 01 ] FCE + SOLUCIONARIO ",url: "https://drive.google.com/file/d/1sz-WQ4yS7S4GMUgZHXz6uqTD0oA5pJ5M/view?usp=sharing"},
            {  titulo:"📝[Test 02 ] FCE + SOLUCIONARIO ",url: "https://drive.google.com/file/d/192v80IEi93ZaiRY1-NkY5h-qk2XyA6O_/view?usp=sharing"},

            {  titulo:"📝[Test] Key Word Transformation 01 ",url: "https://drive.google.com/file/d/1Ng-AL8s5uNqA4AeVSa9x-4ySFH_dqsKU/view?usp=sharing"},
            {  titulo:"📝🔑[Test Answer Key] Key Word Transformation 01 ",url: "https://docs.google.com/presentation/d/1_lR0KYShBJeyFw-ZOuMIEwwLyIdLb2s591vIc4pAIsU/edit?usp=sharing"},

            {  titulo:"📝[Test] Multiple Choice Cloze 01 ",url: "https://drive.google.com/file/d/1Y-2SMBjU5xafwMwdH2VB8NJMWwKQMB5-/view?usp=sharing"},
            {  titulo:"📝🔑[Test Answer Key] Multiple Choice Cloze 01",url: "https://docs.google.com/presentation/d/1koBZiWPQtnw6GgFEfWpNORHWd0TvwYYnRbr661Ahh94/edit?usp=sharing"},

            {  titulo:"📝[Test] Open Cloze 01 ",url: "https://drive.google.com/file/d/1yRCvF2OW3VJfHSqREMmUb4RzAXK6Hfg1/view?usp=sharing"},
            {  titulo:"📝[Test] Word Formation 01 ",url: "https://drive.google.com/file/d/1SOnsELpD7Y4laW2l--YpXeKcut6QM8ZA/view?usp=sharing"},
            {  titulo:"🗣[Test] Speaking Section 01 ",url: "https://drive.google.com/file/d/1tG0g65N35lS8hp1r4LRPDSkynxug5C51/view?usp=sharing"},


        ],
    },{
        id: 21,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "If-Clauses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ IF001 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1zkFdLJpLESep41DLgUElfhiyuBzCU_fi/view?usp=sharing", },
            { titulo: "✍ IF002 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1eQ-z-lbU8tKm_BZgrrgJwfkvl2Erbf2c/view?usp=sharing", },
            { titulo: "✍ IF003 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/182p9f-HK7c0eGODpwB3VstwcwQKgmtH7/view?usp=sharing", },
            { titulo: "✍ IF004 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/19z4Pi3T60d7n505lFrt22npAN8bMZG4d/view?usp=sharing", },
            { titulo: "✍ IF005 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/12FhAI14xsU_5O_Bau-AQFPIQPMwQrIPT/view?usp=sharing", },
            { titulo: "✍ IF006 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/1FiXA09T66glsOEsLQ6zJv86uzRS5NBAC/view?usp=sharing", },
            { titulo: "✍ IF008 - IF-Clauses - Conditional 1 ",url: "https://drive.google.com/file/d/1frj2F8CUX2wo_ASftPHyFFK037reIw9E/view?usp=sharing", },
            { titulo: "✍ IF009 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1dk_3njjacg-x5I-707uoA6ieWhAB8TyU/view?usp=sharing", },
            { titulo: "✍ F010 - IF Clauses - Type 1 ",url: "https://drive.google.com/file/d/1cW9NMcLR6qwyc9TgGIgwcJl41iH9tWMA/view?usp=sharing", },
            { titulo: "✍ IF011 - IF Clauses - Type 2 ",url: "https://drive.google.com/file/d/1H_R3hcWhSwJCTfL____KykDG1pfuyoK5/view?usp=sharing", },
            { titulo: "✍ IF012 - IF Clauses - Type 3 ",url: "https://drive.google.com/file/d/1cG8XOFirGzvJJx7b_Xvv1c1uR38CuBlH/view?usp=sharing", },

            


        ],
    }
    , {
        id: 23,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Present Perfect Tense",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1D0VK7vPjtlAMOc8WqxQUQn62_F3-uJsa/view?usp=sharing", },  
                      { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jgcxBuSKBZ6LdIQbWXL3_4lJDv4D8QVa/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jvFbc4GPFUHXIgx0gmbgslQQz7KmIMG0/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1iCSWPTOFu1vGbkEaW6xSPh-Z_-koKr3V/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1uik-f0MFXujPMnbgmOiCIegxSmWAI5qI/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1CyruZuJFKhWpzmNmFQ9H9oigRjqgY0ui/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1i-A68Tl92LNR87MyIWPPTEceTrIlU_hw/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/11Jj4BydUErvqumFiFy5goX5pGQkZq9HY/view?usp=sharing", },

            
        ],
    }, {
        id: 26,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Future Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Ways of Expressing Future Tense ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },    
            { titulo: "✍  Future Tenses ",url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
            
           

            
        ],
    },
    {
        id: 26,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "TOEFL - Grammar",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Modal Verbs ",url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },    
            
            { titulo: "✍ Comparatives & Modifiers  ",url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },    
            { titulo: "✍ Comparatives & Modifiers II  ",url: "https://drive.google.com/file/d/1XFgGX1sdYUdhvYpKfK4e_Cqj_mQOie3-/view?usp=sharing", },    
            { titulo: "✍ Comparatives & Modifiers III  ",url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },    
            { titulo: "✍ Connectors  ",url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },    
            { titulo: "✍ Correct Sentence Multiple Choice  ",url: "https://drive.google.com/file/d/1fDfIVqWLrLhqVHo-U1WMzsYqzgQ8M1Tr/view?usp=sharing", },    

            { titulo: "✍ Parallel Structures ",url: "https://drive.google.com/file/d/1pTDJGKjUyVQSG6tEne2HdTIcdu96LDuE/view?usp=sharing", },    

            { titulo: "✍Word Choice 1  ",url: "https://drive.google.com/file/d/1QBCWjTJ69eYmnp5LjxD32_sHESeUf2PT/view?usp=sharing", },    
            { titulo: "✍Word Choice 2  ",url: "https://drive.google.com/file/d/11AcnwZ85R7GsoaU0kGKzYwV7wAzadRQ0/view?usp=sharing", },    
            { titulo: "✍Word Choice 3  ",url: "https://drive.google.com/file/d/1mYW1BkrSOc_JDU0e-bH2w6-S5MwBg6LV/view?usp=sharing", },    
            { titulo: "✍Word Choice 4  ",url: "https://drive.google.com/file/d/15BawZ93O21V7AC3mR_4sW29hzftMdMNd/view?usp=sharing", },    
            { titulo: "✍Noun Phrases ",url: "https://drive.google.com/file/d/16oHUr1WoZ8h3OuKA3J_i7h_4-yrDMWpy/view?usp=sharing", },    
            { titulo: "✍Noun Phrases 2 ",url: "https://drive.google.com/file/d/1YHlLWaR-D7oOGE7nsit_ciUJOyhGg__u/view?usp=sharing", },    
            { titulo: "✍Verbs & Tenses ",url: "https://drive.google.com/file/d/1maGomb9hSFctNQciK0iQ65MS6NcBmyB9/view?usp=sharing", },    
            { titulo: "✍Verbs & Tenses 2 ",url: "https://drive.google.com/file/d/1hmNX83_c71spUojY26NX0Lr1xu8lFatr/view?usp=sharing", },    
            { titulo: "✍Negative Word Choice  ",url: "https://drive.google.com/file/d/1EIhDVNF1zmA3aHY5GWLMlY8yFfU0YvsJ/view?usp=sharing", },    
            
            { titulo: "✍ Pronouns Multiple Choice  ",url: "https://drive.google.com/file/d/1NW1tqZPEhz_x-C3R_JkIxlPI2AEpo2Ip/view?usp=sharing", },    
            { titulo: "✍Prepositions 1 ",url: "https://drive.google.com/file/d/1zBC_Z2Yx-v6snlVv04J7f3phtsltg9ZJ/view?usp=sharing", },    
            { titulo: "✍Prepositions 2 ",url: "https://drive.google.com/file/d/1RmqHsasdx0v9YIwCH5-kQkgYl8N-PtFB/view?usp=sharing", },    
            { titulo: "✍Much or Many Exercise  ",url: "https://drive.google.com/file/d/1RCGY76NB6Sw920zvaJ5XDSdHxFv3VrCh/view?usp=sharing", },    
            { titulo: "✍ Some or Many Exercise  ",url: "https://drive.google.com/file/d/1FnvjpGc0aO_CYRW4X029MTHsiXeSc4nu/view?usp=sharing", },    
            { titulo: "✍ Last or Latter Exercise  ",url: "https://drive.google.com/file/d/1cg_ddekwaAS49iRAbDxV0CiJlM3Y9o0R/view?usp=sharing", },    
            { titulo: "✍ Superlatives  Exercise  ",url: "https://drive.google.com/file/d/1MfGGvdY2UGYMWWYg4y6pMWx6x9ijW85J/view?usp=sharing", },    
            { titulo: "✍ Past Tense  Exercise  ",url: "https://drive.google.com/file/d/1xqAs1XF73eyqoH7hnyCpg_9QobkecHca/view?usp=sharing", },    
            { titulo: "✍ Conditional Matching Exercise ",url: "https://drive.google.com/file/d/1pceZifEmXB5sk-AmhG4GqP00Tj63rFVA/view?usp=sharing", },    

            { titulo: "✍ Gerund or Infinitive Exercise  ",url: "https://drive.google.com/file/d/1FAsG76_HqxXJIftk59cJIuM-wbXupH93/view?usp=sharing", },    
            {  titulo:"[📑5 Phrasal Verbs", url: "https://www.flippity.net/fc.php?k=e/2PACX-1vTaKWxtCnp5jo1jD77xTbihIoF3TG1eUiBh8mS14kM4o64z9-bSQGfIh_MoMmbDPdrlFV-z-b8XXZgx"},
            {  titulo:"[📑sIMULACION", url: "https://learnibox.vercel.app/CambridgeExam"},
        ],
    },
    {
        id: 26,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Finalizacion del Curso",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "Descargar Certificación",url: "learnibox.vercel.app/Certificate", },    
         
        ],
    },
    {
        id: 26,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Finalizacion del Curso",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "Descargar Certificación",url: "https://drive.google.com/file/d/1xNdjFuVgRQT55yOURQjR-c9d3ObNh8vU/view?usp=sharing", },    
         
        ],
    }
];
